import { z } from 'zod';

export const enrollmentSchema = z.object({
  fullName: z.string().min(3, 'O nome deve ter no mínimo 3 caracteres'),
  citizenId: z.string().min(1, 'O ID do cidadão é obrigatório'),
  phone: z.string().length(6, 'O telefone deve ter exatamente 6 dígitos'),
  password: z.string().min(6, 'A senha deve ter no mínimo 6 caracteres'),
  confirmPassword: z.string().min(6, 'A confirmação de senha é obrigatória'),
  courses: z.array(z.string()).min(1, 'Selecione pelo menos um curso')
}).refine(data => data.password === data.confirmPassword, {
  message: "As senhas não coincidem",
  path: ["confirmPassword"]
});

export const professorSchema = z.object({
  fullName: z.string().min(3, 'O nome deve ter no mínimo 3 caracteres'),
  citizenId: z.string().min(1, 'O ID do cidadão é obrigatório'),
  phone: z.string().length(6, 'O telefone deve ter exatamente 6 dígitos'),
  courses: z.string().min(1, 'Cursos são obrigatórios'),
  password: z.string().min(6, 'A senha deve ter no mínimo 6 caracteres'),
  confirmPassword: z.string().min(6, 'A confirmação de senha é obrigatória')
}).refine(data => data.password === data.confirmPassword, {
  message: "As senhas não coincidem",
  path: ["confirmPassword"]
});
